import { Timestamp } from 'firebase/firestore';

export const ACTIVITY_TYPES = [
  'watered',
  'repotted',
  'fertilized',
  'pruned',
  'treated',
  'moved',
  'note',
] as const;

export type ActivityType = (typeof ACTIVITY_TYPES)[number];

export interface Activity {
  id: string;
  plantId: string;
  plantName: string;
  plantPhotoURL: string;
  type: ActivityType;
  note: string | null;
  createdAt: Timestamp;
}

export interface CreateActivityInput {
  plantId: string;
  plantName: string;
  plantPhotoURL: string;
  type: ActivityType;
  note?: string | null;
}

export interface UpdateActivityInput {
  note?: string | null;
}

// Icons chosen to match existing app icon vocabulary (material-symbols-outlined)
export const ACTIVITY_META: Record<ActivityType, { icon: string; label: string; color: string }> = {
  watered: { icon: 'water_drop', label: 'Watered', color: 'text-blue-500' },
  repotted: { icon: 'potted_plant', label: 'Repotted', color: 'text-amber-700' },
  fertilized: { icon: 'nutrition', label: 'Fertilized', color: 'text-green-600' },
  pruned: { icon: 'content_cut', label: 'Pruned', color: 'text-orange-500' },
  treated: { icon: 'healing', label: 'Treated', color: 'text-red-500' },
  moved: { icon: 'home', label: 'Moved', color: 'text-purple-500' },
  note: { icon: 'edit_note', label: 'Note', color: 'text-gray-500' },
};
